export const HELP_EMAIL = "help@apropo.io";
export const HELLO_EMAIL = "hello@apropo.io";
export const BILLING_EMAIL = "billing@apropo.io";